import { __awaiter, __generator } from "tslib";
import { fetchEntity } from './http/fetch-entity';
export var fetchFamily = function (familyId, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchEntity(familyId, "f" /* Family */, includeType)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
